import React from 'react';
import proptypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Button } from '@one-thd/sui-atomic-components';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { FEATURE_SWITCH_KEYS } from '../../constants';

const { bool } = proptypes;

const SpecialBuyNavButton = ({ isFullWidth }) => {
  const { specialBuyType, isFallbackBanner, specialBuyEndpoint } = useSpecialBuy();
  const isDailyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isDailyDealsEnabled);
  const isWeeklyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isWeeklyDealsEnabled);

  return (
    <Button
      variant="primary"
      href={specialBuyEndpoint}
      fullWidth={isFullWidth}
    >
      {isFallbackBanner ? (
        // for non-specialbuytype scenario
        <>Shop&nbsp;All&nbsp;Savings</>
      ) : (
        // for specialbuytype('sbotd', 'pro') scenario
        <>
          {specialBuyType === 'sbotd' && (
            <>
              {isDailyDealsEnabled ? (
                <>Shop&nbsp;Daily&nbsp;Deals</>
              ) : (
                <>Shop&nbsp;Today&apos;s&nbsp;Specials</>
              )}
            </>
          )}
          {specialBuyType === 'pro' && (
            <>
              {isWeeklyDealsEnabled ? (
                <>Shop&nbsp;Weekly&nbsp;Deals</>
              ) : (
                <>Shop&nbsp;Pro&nbsp;Specials</>
              )}
            </>
          )}
        </>
      )}
    </Button>
  );
};

SpecialBuyNavButton.displayName = 'SpecialBuyNavButton';

SpecialBuyNavButton.propTypes = {
  isFullWidth: bool,
};

SpecialBuyNavButton.defaultProps = {
  isFullWidth: false,
};

export { SpecialBuyNavButton };
